import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const HomeCCOContent = () => {
  const navigate = useNavigate();

  const machines = [
    { id: 'rd', title: 'RD', subtitle: 'Raddrizzatrici', path: '/raddrizzatrici', icon: 'Settings2', color: 'from-orange-500 to-orange-600', description: 'Manutenzione e monitoraggio raddrizzatrici.' },
    { id: 'banchi', title: 'BANCHI', subtitle: 'Oscillanti', path: '/banchi-oscillanti', icon: 'Activity', color: 'from-orange-500 to-orange-600', description: 'Stato banchi e sistemi di oscillazione stampo.' },
    { id: 'carri', title: 'CARRI', subtitle: 'Ossitaglio', path: '/carri-ossitaglio', icon: 'Scissors', color: 'from-orange-500 to-orange-600', description: 'Gestione componenti taglio e carri ossitaglio.' },
    { id: 'cilindri', title: 'CILINDRI', subtitle: 'Paniera', path: '/cilindri-paniera', icon: 'Database', color: 'from-orange-500 to-orange-600', description: 'Revisione cilindri idraulici e componenti paniera.' },
    { id: 'acqua', title: 'ACQUA', subtitle: 'Controllo Sistemi', path: '/controllo-acqua', icon: 'Droplets', color: 'from-cyan-500 to-cyan-600', description: 'Monitoraggio circuiti di raffreddamento e filtri.' }
  ];

  return (
    <div className="w-full animate-in fade-in slide-in-from-bottom-6 duration-1000 ease-out">
      
      {/* HEADER */}
      <div className="mb-12">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-[2px] bg-orange-500 rounded-full" />
          <span className="text-[10px] font-black uppercase tracking-[0.5em] text-orange-500">Reparto Colata Continua</span>
        </div>
        <h2 className="text-4xl md:text-6xl font-black tracking-tighter text-foreground">CCO Control Panel</h2>
      </div>

      {/* SEZIONE 1: MAGAZZINO, STORICO & CHECKLIST */}
      <div className="mb-16">
        <h3 className="text-xs font-black uppercase tracking-[0.3em] text-muted-foreground/50 mb-6 px-2">Logistica & Spare Parts</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          
          {/* RICAMBI CARD - Puna širina na mobilnim, col-span-2 na desktopu */}
          <button
            onClick={() => navigate('/ricambi-cco')}
            className="md:col-span-2 group relative flex items-center bg-card rounded-[2.5rem] border border-border/40 overflow-hidden transition-all duration-500 hover:border-blue-500/40 hover:shadow-[0_30px_60px_-15px_rgba(37,99,235,0.2)]"
          >
            <div className="absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-b from-blue-500 to-blue-700" />
            <div className="p-8 lg:p-10 flex flex-col sm:flex-row items-center justify-between w-full gap-6">
              <div className="flex items-center gap-6 text-left">
                <div className="w-16 h-16 rounded-2xl bg-blue-600/10 flex items-center justify-center text-blue-600 group-hover:bg-blue-600 group-hover:text-white transition-all duration-500 shadow-lg">
                  <Icon name="Package" size={32} />
                </div>
                <div>
                  <h4 className="text-3xl font-black tracking-tighter uppercase">Ricambi</h4>
                  <p className="text-[10px] font-black uppercase tracking-widest text-blue-500">Gestione Magazzino</p>
                </div>
              </div>
              <p className="hidden lg:block max-w-[180px] text-[11px] text-muted-foreground font-bold leading-tight opacity-60">Controllo scorte, cuscinetti e minuteria tecnica.</p>
              <div className="w-12 h-12 rounded-full bg-muted flex items-center justify-center group-hover:bg-blue-600 group-hover:text-white transition-all">
                <Icon name="ArrowRight" size={20} />
              </div>
            </div>
          </button>

          {/* STORICO MOVIMENTI CARD */}
          <button
            onClick={() => navigate('/storico-cco')}
            className="group relative flex items-center bg-card rounded-[2.5rem] border border-border/40 overflow-hidden transition-all duration-500 hover:border-emerald-500/40 hover:shadow-[0_30px_60px_-15px_rgba(16,185,129,0.15)]"
          >
            <div className="absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-b from-emerald-500 to-emerald-700" />
            <div className="p-8 flex items-center justify-between w-full gap-4">
              <div className="flex items-center gap-4 text-left">
                <div className="w-14 h-14 rounded-2xl bg-emerald-600/10 flex items-center justify-center text-emerald-600 group-hover:bg-emerald-600 group-hover:text-white transition-all duration-500 shadow-lg">
                  <Icon name="History" size={28} />
                </div>
                <div>
                  <h4 className="text-xl font-black tracking-tighter uppercase leading-none">Storico</h4>
                  <p className="text-[9px] font-black uppercase tracking-widest text-emerald-500 mt-1">Movimenti</p>
                </div>
              </div>
              <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center group-hover:bg-emerald-600 group-hover:text-white transition-all">
                <Icon name="ArrowUpRight" size={18} />
              </div>
            </div>
          </button>

          {/* CHECKLIST CARD */}
          <button
            onClick={() => navigate('/cco-checklist')}
            className="group relative flex items-center bg-card rounded-[2.5rem] border border-border/40 overflow-hidden transition-all duration-500 hover:border-purple-500/40 hover:shadow-[0_30px_60px_-15px_rgba(168,85,247,0.15)]"
          >
            <div className="absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-b from-purple-500 to-purple-700" />
            <div className="p-8 flex items-center justify-between w-full gap-4">
              <div className="flex items-center gap-4 text-left">
                <div className="w-14 h-14 rounded-2xl bg-purple-600/10 flex items-center justify-center text-purple-600 group-hover:bg-purple-600 group-hover:text-white transition-all duration-500 shadow-lg">
                  <Icon name="ClipboardCheck" size={28} />
                </div>
                <div>
                  <h4 className="text-xl font-black tracking-tighter uppercase leading-none">Checklist</h4>
                  <p className="text-[9px] font-black uppercase tracking-widest text-purple-500 mt-1">Controlli</p>
                </div>
              </div>
              <div className="w-10 h-10 rounded-full bg-muted flex items-center justify-center group-hover:bg-purple-600 group-hover:text-white transition-all">
                <Icon name="ArrowUpRight" size={18} />
              </div>
            </div>
          </button>

        </div>
      </div>

      {/* SEZIONE 2: MACCHINE */}
      <div>
        <h3 className="text-xs font-black uppercase tracking-[0.3em] text-muted-foreground/50 mb-6 px-2">Gestione Impianti</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {machines.map((mac) => (
            <button
              key={mac.id}
              onClick={() => navigate(mac.path)}
              className="group relative flex flex-col bg-card rounded-[2rem] border border-border/40 overflow-hidden transition-all duration-500 hover:border-orange-500/40 hover:-translate-y-2 hover:shadow-xl"
            >
              <div className={`h-1.5 w-full bg-gradient-to-r ${mac.color} opacity-70 group-hover:opacity-100`} />
              <div className="p-6 flex flex-col h-full text-left">
                <div className="flex justify-between items-start mb-8">
                  <div className={`w-12 h-12 rounded-2xl bg-gradient-to-br ${mac.color} flex items-center justify-center text-white shadow-lg`}>
                    <Icon name={mac.icon} size={24} />
                  </div>
                  <Icon name="Plus" size={16} className="text-muted-foreground group-hover:rotate-90 transition-transform" />
                </div>
                <div className="flex-grow">
                  <h5 className="text-2xl font-black tracking-tighter uppercase leading-none">{mac.title}</h5>
                  <p className="text-[10px] font-bold text-orange-500 uppercase tracking-widest mb-3 mt-1">{mac.subtitle}</p>
                  <p className="text-[11px] text-muted-foreground font-medium leading-tight opacity-70 italic">{mac.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomeCCOContent;